import { Badge } from "@/components/ui/badge"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardFooter } from "@/components/ui/card"
import { Archive, Trophy } from "lucide-react"
import { Link } from "react-router-dom"

export const SeasonInfo = ({ game, season }) => {
  if (!game || !season) return null

  return (
    <Card className="bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 overflow-hidden">
      {/* Game banner */}
      {game.urlImage && (
        <div className="relative">
          <img src={game.urlImage} alt={game.name} className="w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
          <span className="absolute bottom-2 left-3 text-white text-xs font-semibold drop-shadow">
            {game.name}
          </span>
        </div>
      )}

      <CardContent className="px-4 pt-3 pb-2 space-y-2">
        {/* Header strip */}
        <div className="flex items-center gap-2 border-b border-muted/40 dark:border-gray-700 pb-2">
          <Trophy className="h-4 w-4 text-muted-foreground shrink-0" />
          <span className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
            Temporada
          </span>
        </div>

        {/* Season identity */}
        <div>
          <h4 className="font-semibold text-sm leading-tight">{season.name}</h4>
          {season.description && (
            <p className="mt-0.5 text-xs text-muted-foreground dark:text-gray-400 line-clamp-2">
              {season.description}
            </p>
          )}
        </div>

        {/* Badges */}
        <div className="flex flex-wrap gap-1.5">
          <Badge
            className={`text-[10px] px-1.5 py-0 border-0 ${
              season.isActive
                ? "bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-400"
                : "bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-400"
            }`}
          >
            {season.isActive ? "Activa" : "Inactiva"}
          </Badge>
          {season.isArchived === 1 && (
            <Badge className="text-[10px] px-1.5 py-0 bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-400 border-0">
              <Archive className="w-2.5 h-2.5 mr-1" />
              Archivada
            </Badge>
          )}
        </div>
      </CardContent>

      {season.rankingUrl && (
        <CardFooter className="px-4 pb-4 pt-0">
          <Button variant="outline" size="sm" className="w-full" asChild>
            <Link to={season.rankingUrl} rel="noopener noreferrer">
              Ver ranking
            </Link>
          </Button>
        </CardFooter>
      )}
    </Card>
  )
}
